export default __webpack_public_path__ + "static/media/campaign-stop.f1d7f27a.svg";